export default __webpack_public_path__ + "static/media/powerladder_policy_v2.425a33ac.png";